export default (scopes, tId) => {
	return [
		...scopes.map((scope) => {
			return {
				...scope,
				teamList: [
					...scope.teamList.map((team) => {
						let t = {...team};
						if (t.teamId === tId) {
							t.selected = !t.selected;
							return t;
						}

						return t;
					})
				]
			};
		})
	];
};